import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { PayableSubject } from '../types'
import { isSubjectInvoice } from './isSubjectInvoice'

export const isExternalInvoice = (subject: PayableSubject): boolean => {
  /* Both bills and invoices can have credit notes */
  /* In this particular case we filter out all invoice credit notes, both billy and zervant */
  /* But by accountingBasis we only filter out external invoices of them */
  /* Therefore Billy invoices credit notes will return false in this condition */
  const isInvoiceCreditNote = isSubjectInvoice(subject) && subject.type === InvoiceType.CreditNote

  return (
    (subject.type === InvoiceType.Invoice || isInvoiceCreditNote) &&
    'accountingBasis' in subject &&
    !!subject.accountingBasis
  )
}
